import { render, staticRenderFns } from "./TabUseList.vue?vue&type=template&id=674990e1&scoped=true&"
import script from "./TabUseList.vue?vue&type=script&lang=js&"
export * from "./TabUseList.vue?vue&type=script&lang=js&"
import style0 from "./TabUseList.vue?vue&type=style&index=0&id=674990e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674990e1",
  null
  
)

export default component.exports